module.exports = __webpack_public_path__ + "media/img/crono-dff766eab60f006bc413802165874b75.png";